<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1></h1>
<p>Life itself seems lunatic</p>
<p style="text-indent: 00em !important;">Who knows where madness lies?</p>
<p style="text-indent: 00em !important;">Perhaps to be too practical is madness,</p>
<p style="text-indent: 00em !important;">To surrender dreams, this may be madness,</p>
<p style="text-indent: 00em !important;">To seek treasure where there is only trash</p>
<p style="text-indent: 00em !important;">Too much sanity may be madness?</p>
<p style="text-indent: 00em !important;">But the maddest of all is to see life as it is and not as it should be.</p>
<p style="text-align: right;">DON QUIXOTE-<em>Cervantes</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?9cd58eea